import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as $ from 'jquery';

import { Steps, Configurations } from '../../../common/Steps';
import { Step } from '../../groupComputation/Step';
import {
    ILoggerService,
    ITaskService,
    IwidgetIntervalHelperService,
    IGroupService,
    ICurrentApplicationService,
    ExcludedDates
} from '../../../services';
import { ComponentDefinition, IFrequency, IGroupConfiguration, WorkflowTaskConfiguration } from '../../../models';

class LaunchCalculationModalController implements angular.IComponentController {
    batchFrequency: IFrequency;
    configuration: WorkflowTaskConfiguration;
    excludedDates: ExcludedDates[];
    frequency: IFrequency;
    groupGuid: string;
    id: string;
    isComputing: boolean;
    isLoading: boolean;
    isRefreshPrevented: boolean = true;
    preventClose: boolean;
    steps: Step[];

    private _steps: { label: string; propertyName: string }[];
    private _timer: angular.IPromise<void>;

    static $inject = [
        '$scope',
        '$timeout',
        'loggerService',
        'taskService',
        'widgetIntervalHelperService',
        'groupService',
        'currentApplicationService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$timeout: angular.ITimeoutService,
        private _loggerService: ILoggerService,
        private _taskService: ITaskService,
        private _widgetIntervalHelperService: IwidgetIntervalHelperService,
        private _groupService: IGroupService,
        private _currentApplicationService: ICurrentApplicationService
    ) {
        this._steps = Steps.concat(Configurations);
    }

    $onInit() {
        this._steps = Steps.concat(Configurations);
        this.preventClose = true;
        if (this.groupGuid) {
            this.loadGroupConfig(this.groupGuid);
        }
        // use of $timeout to hook to event after DOM is rendered
        this._timer = this._$timeout(() => {
            $(`#${this.id}`).on('hidden.bs.modal', e => {
                this.preventClose = true;
                this.excludedDates = null;
                this._$scope.$apply();
            });
        });
    }

    $onChanges(changes: angular.IOnChangesObject): void {
        if (changes['groupGuid']?.currentValue) {
            if (this.groupGuid) {
                this.loadGroupConfig(this.groupGuid);
            }
        }
    }

    $onDestroy() {
        this._$timeout.cancel(this._timer);
    }

    createTask(): void {
        if (this.excludedDates) {
            this.startTask();
        }
        else {
            this.configuration = this.createConfiguration();
            this.configuration.batchFrequency = this.batchFrequency;
            if (this._currentApplicationService.getApplicationConfiguration().validationEnabled) {
                this.isLoading = true;
                this._taskService.checkWorkflowTask(this.createConfiguration())
                    .then(data => {
                        const dates = _.chain(data)
                            .map(d => d.value)
                            .flatten()
                            .uniq()
                            .sortBy(d => d)
                            .map((d: string) => new Date(d))
                            .value();
                        if (dates.length > 0) {
                            this.excludedDates = data.map(d => {
                                return {
                                    key: d.key,
                                    value: _.chain(d.value)
                                        .map(dd => moment(dd).startOf('d').toISOString())
                                        .uniq()
                                        .value()
                                };
                            });
                        } else {
                            this.startTask();
                        }
                    })
                    .finally(() => this.isLoading = false);
            } else {
                this.startTask();
            }
        }
    }

    private startTask() {
        $(`#${this.id}`).modal('hide');
        this._taskService.createWorkflowTask(this.configuration)
            .then(data => {
                if (data >= 0) {
                    this._loggerService.logSuccess('Task successfully created');
                } else {
                    switch (data) {
                        case -2:
                            this._loggerService.logError('Tasks cannot be executed on a child application');
                            break;
                        default: this._loggerService.logError('Failed to create task');
                            break;
                    }
                }
            })
            .catch(() => this._loggerService.logError('Failed to create task.'));
    }

    private createConfiguration(): WorkflowTaskConfiguration {
        const interval = this._widgetIntervalHelperService.getCurrentInterval();
        const configuration: any = {
            beginDateTime: interval.beginDate,
            endDateTime: interval.endDate,
            groupGuid: this.groupGuid
        };

        this._steps.forEach((s, i) => {
            configuration[s.propertyName] = this.steps[i].value;
        });
        return configuration;
    }

    private loadGroupConfig(groupGuid: string): angular.IPromise<IGroupConfiguration> {
        return this._groupService
            .getConfigurationForGroup(groupGuid)
            .then(data => {
                this.steps = this.mapSteps(data);
                return data;
            })
            .catch(() => {
                this.steps = this.mapSteps();
                return null;
            });
    }

    private mapSteps(data?): Step[] {
        return this._steps.map(d => {
            return {
                label: d.label,
                value: data ? !!data[d.propertyName] : false
            };
        });
    }
}

export const wtLaunchCalculationModal: ComponentDefinition = {
    componentId: 'wtLaunchCalculationModal',
    controller: LaunchCalculationModalController,
    controllerAs: 'vm',
    template: require('./launchCalculationModal.component.html'),
    bindings: {
        groupGuid: '<',
        initialRange: '<',
        frequency: '<?',
        id: '@'
    }
};